import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { AuthService } from "../../guards/auth/auth.service";
import { LocalDB } from '../../../shared/utils';

@Component({
    selector: 'convfact-logout',
    template: `logout page`,
    standalone: false
})

export class LogoutComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    ngOnInit() { 
        this.authService.logout();
        this.router.navigate(['/']);
    }
}
